export default "__VITE_ASSET__ZAES2HcfJ9sHdMfNSDSxmw__"